import React from 'react'
import { Group, MultiSelect, Paper, Stack, TagsInput } from '@mantine/core'
import { useGetJobBoardJobCategoriesQuery, useGetJobBoardJobTypesQuery } from '../redux/query/jobBoardApi.slice'
import ErrorLoading from '../../../react/core/ErrorLoading'
import Loading from '../../../react/core/Loading'

function JobFilters ({ filters, setFilters }) {
  const { data: categories, error: categoriesError, isLoading: categoriesLoading } = useGetJobBoardJobCategoriesQuery({ limit: 0 })
  const { data: types, error: typesError, isLoading: typesLoading } = useGetJobBoardJobTypesQuery({ limit: 0 })

  if (categoriesError || typesError) {
    return <ErrorLoading />
  }

  if (categoriesLoading || typesLoading) {
    return <Loading />
  }

  return (
    <Paper>
      <Stack>
        <Group grow>
          <MultiSelect
            label='Job categories'
            placeholder={filters.job_categories.length === 0 ? 'Filter by job categories' : null}
            data={
              categories.items.map(category => ({
                value: category.id.toString(),
                label: category.name
              }))
            }
            value={filters.job_categories}
            onChange={value => setFilters(prevState => ({ ...prevState, job_categories: value }))}
            searchable
            clearable
          />
          <MultiSelect
            label='Job types'
            placeholder={filters.job_types.length === 0 ? 'Filter by job types' : null}
            data={
              types.items.map(type => ({
                value: type.id.toString(),
                label: type.name
              }))
            }
            value={filters.job_types}
            onChange={value => setFilters(prevState => ({ ...prevState, job_types: value }))}
            searchable
            clearable
          />
        </Group>
        <TagsInput
          label='Keywords'
          description='Add up to 3 keywords'
          placeholder={filters.keywords.length === 0 ? 'Filter by keywords' : null}
          data={[]}
          value={filters.keywords}
          onChange={value => setFilters(prevState => ({ ...prevState, keywords: value }))}
          maxTags={3}
          clearable
        />
      </Stack>
    </Paper>
  )
}

export default React.memo(JobFilters)
